import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import LoadingSpinner from "./components/LoadingSpinner";
import AppsPage from "./pages/AppsPage";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
import MailboxUsersPage from "./pages/MailboxUsersPage";
import MicrosoftCallbackPage from "./pages/MicrosoftCallbackPage";
import GoogleCallbackPage from "./pages/GoogleCallbackPage";
import ProfilePage from "./pages/ProfilePage";
import UsersPage from "./pages/UsersPage";
import useAuthStore from "./stores/authStore";

function App() {
  const { user, loading, init } = useAuthStore();

  useEffect(() => {
    // 認証状態を初期化（初回のみ実行）
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/microsoft/callback" element={<MicrosoftCallbackPage />} />
        <Route path="/auth/google/callback" element={<GoogleCallbackPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="apps" element={<AppsPage />} />
        <Route path="apps/webmail/mailboxes" element={<MailboxUsersPage />} />
        <Route path="profile" element={<ProfilePage />} />
      </Route>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/microsoft/callback" element={<MicrosoftCallbackPage />} />
      <Route path="/auth/google/callback" element={<GoogleCallbackPage />} />
    </Routes>
  );
}

export default App;
